import {
  toWSDateString,
  WSFilterOption
} from "@wingspanhq/fe-component-library";
import { BatchStatus, BatchType } from "@wingspanhq/wingspan-api-sdk";
import { queriesBatches } from "@query";
import { useMemo } from "react";

import { selectorPayableImportBatchName } from "../../../../BulkImporter/selectors/selectorPayableImportBatchName";

/**
 * Builds the select options for the "Bulk batch" payables filter from the
 * completed/failed payable import batches.
 */
export function useBulkBatchFilterOptions(): WSFilterOption<"checkbox">[] {
  const query = queriesBatches.listBatches.useQueryAll({
    filter: {
      type: { eq: BatchType.PAYABLE_IMPORT },
      status: { anyOf: [BatchStatus.COMPLETED, BatchStatus.FAILED] }
    }
  });

  return useMemo(
    () =>
      (query.flatData ?? []).map(batch => ({
        name: batch.id as string,
        label:
          selectorPayableImportBatchName(batch) +
          (batch.events?.createdAt
            ? ` (created ${toWSDateString(batch.events.createdAt)})`
            : "")
      })),
    [query.flatData]
  );
}
